<div
    [ngClass]="{
        student: student,
        'auth-button': !mobile,
        'auth-mobile-button': mobile
    }"
    [ngStyle]="setWidth()"
>
    <span
        (click)="student ? openStudentAuthModal() : openAuthModal()"
        class="selenium-open-sign-in"
    >
        {{ text ? text : "Sign In" }}
    </span>
    <ng-container *ngIf="!text">
        <span *ngIf="!mobile" class="vertical-bar-container">
            <span class="vertical-bar"></span>
        </span>
        <a
            *ngIf="!student"
            [routerLink]="['/signup']"
            class="selenium-open-sign-up"
        >
            Sign Up
            <app-icon
                *ngIf="showSocialIcons"
                [type]="'Facebook-square'"
            ></app-icon>
            <app-icon *ngIf="showSocialIcons" [type]="'Google'"></app-icon>
        </a>
        <a
            *ngIf="student"
            [routerLink]="['/student/signup']"
            queryParamsHandling="merge"
        >
            Sign Up
            <app-icon *ngIf="showSocialIcons" [type]="'Google'"></app-icon>
        </a>
    </ng-container>
</div>
